module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//9.jpg?8b66c24af12362e2370f8fe41b210682";